<template>
  <section id="festival" class="spacer nb half">
    <div class="title big mbig">{{ festival.title }}</div>
    <div class="pt mbs big" v-html="festival.text"></div>
    <testimonials />
  </section>
</template>

<script>
import API from "@/api/service";
import Testimonials from "@/components/Testimonials.vue";
export default {
  components: {
    Testimonials,
  },
  data() {
    return {
      festival: [],
    };
  },
  watch: {
    $route() {
      API.festival(this.$i18n.locale).then((page) => {
        this.festival = page.data.result;
      });
    }
  },
  created() {
    API.festival(this.$i18n.locale).then((page) => {
      this.festival = page.data.result;
    });
  },
};
</script>

<style></style>
